import { useEffect, useState, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BackDropLoader from '../components/BackDropLoader';
import { useAuth } from '../contexts/authContext';
import { TrainingBlock } from '../features/trainingSession/components/TrainingBlock';
import { TrainingSessionMobileBlock } from '../features/trainingSession/components/TrainingSessionMobileBlock';
import { getAllPersonalTraining } from '../features/trainingSession/services/trainingSessionService';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

export default function TrainingSessionPage() {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true); // Initialize loading to true
  const [trainingsData, setTrainingsData] = useState({ trainings: [] });
  const auth = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const fetchData = useCallback(async () => {
    setLoading(true); // Set loading to true before fetching data
    try {
      // Replace with actual API call for personal trainings
      const response = await getAllPersonalTraining(auth.user.id);
      setTrainingsData({ trainings: response });
    } catch (error) {
      enqueueSnackbar(<FormattedMessage id="trainings.get.msg.error" defaultMessage="Failed to fetch personal trainings" />, { variant: 'error' });
      setTrainingsData({ trainings: [] });
    } finally {
      setLoading(false); // Set loading to false after the data is fetched
    }
  }, [auth.user.id, enqueueSnackbar]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleRowClick = (rowData) => {
    navigate(`/dashboard/training-session/${rowData.id}`);
  };

  return (
    <div>
      <BackDropLoader open={loading} />
      {isSmallScreen ? (
        <TrainingSessionMobileBlock
          trainingsData={trainingsData}
          handleRowClick={handleRowClick}
        />
      ) : (
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <TrainingBlock
              trainingsData={trainingsData}
              loading={loading}
              handleRowClick={handleRowClick}
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
}
